import project1 from "@/assets/projects/project1.png";
import Synex from "@/assets/projects/synex.webp";
import MYportfolio from "@/assets/projects/MYportfolio.png";
import NavTantra from "@/assets/projects/NavTantra.webp";
import meetify from "@/assets/projects/meetify.webp";
import blogs from "@/assets/projects/Blogs.webp";

export const PROJECTS = [
  {
    image: project1,
    title: "MunSarthi — MUN Management",
    description:
      "Real-time committee dashboards, collaborative scoring, speaker queue, motions, and secure role-based access built with React, Firebase, and TailwindCSS.",
    tags: ["React", "Firebase", "TailwindCSS", "JavaScript"],
    live: "https://munsarthi.ishan.vip",
  },
  {
    image: MYportfolio,
    title: "Portfolio Website",
    description:
      "A showcase of my work, skills, and experience built with React, TailwindCSS, and Vite.",
    tags: ["React", "TailwindCSS", "JavaScript"],
    live: "https://old.ishan.vip",
    repo: "https://github.com/NavIshanOp/MY-PORTFOLIO",
  },
  {
    image: Synex,
    title: "Synex",
    description:
      "Ultimate Discord Bot: Moderation, Music, AI, Automation, Fun & More!",
    tags: ["Node.js"],
    live: "https://discord.com/oauth2/authorize?client_id=1273604845789515806&permissions=8&integration_type=0&scope=bot",
  },
  {
    image: NavTantra,
    title: "NavTantra",
    description:
      "Sunbeam Lahartara's Robotics Club: Innovating minds, creating the future.",
    tags: ["React", "JSX", "JavaScript"],
    live: "https://navtantra.ishan.vip",
  },
  {
    image: meetify,
    title: "Meetify",
    description:
      "Video calling website with screen share.",
    tags: ["HTML", "CSS", "TypeScript"],
    live: "https://meetify.ishan.vip",
    repo: "https://github.com/NavIshanOp/Meetify",
  },
  {
    image: blogs,
    title: "Blogs Website",
    description:
      "A personal blog website built with React and Node.js.",
    tags: ["React", "Node.js"],
    live: "https://blogs.ishan.vip",
    repo: "https://github.com/NavIshanOp/Blogs",
  },
];